// Popups (Modals, ...)

let popups = {
    modals: {}
};


window.initModals = function ()
{
    document.querySelectorAll('[data-custom-modal-show]').forEach(function (modal) {
        popups.modals[modal.id] = new Modal(modal);

        if (modal.getAttribute('data-custom-modal-show').toLowerCase() == 'true') {
            popups.modals[modal.id].show();
        }
    });
}

window.showModal = function (modalId)
{
    popups.modals[modalId].show();
    window.dispatchEvent(new CustomEvent(modalId, { bubble: true, detail: { open: true }}));
}

window.hideModal = function (modalId)
{
    popups.modals[modalId].hide();
    window.dispatchEvent(new CustomEvent(modalId, { bubble: true, detail: { open: false }}));
}

window.getModal = function (modalId)
{
    return popups.modals[modalId];
}



initModals();
